import { render, staticRenderFns } from "./cancelled-list.vue?vue&type=template&id=561b7ff9&"
import script from "./cancelled-list.vue?vue&type=script&lang=js&"
export * from "./cancelled-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports